const style = {
  totalsWrapper: {
    marginBottom: '24px',
    display: 'grid',
    gridTemplateColumns: '20% 20% 20% 20% 20%',
  },
  totalsCardWrapper: {
    padding: 0,
    margin: '10px 20px 10px 0px',
    '&:last-of-type': {
      margin: '10px 0px 10px 0px',
    },
  },
  zeroMargin: {
    margin: 0,
  },
  card: {
    padding: '14px',
    boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px',
    borderRadius: '10px',
  },

  cardTitle: {
    width: '100%',
    // margin: '0 15px 24px 15px',
  },
  cardValue: {
    fontSize: '18px',
    fontWeight: 'bold',
  },
  moreIconWrapper: { height: '97px', position: 'relative' },
  moreIcon: {
    position: 'absolute',
    right: 0,
    fill: '#C4C4C4',

    '&:hover': {
      cursor: 'pointer',
    },
  },
}

export default style
